import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LuckyWheelNavButton } from './lucky-wheel/LuckyWheelNavButton';

function NavIcon({ name }: { name: string }) {
  const common = { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', 'aria-hidden': true as const };
  switch (name) {
    case 'wallet':
      return (
        <svg {...common}>
          <rect x="3" y="6" width="18" height="13" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3 10h18" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="16.5" cy="14.5" r="1.2" fill="currentColor" />
        </svg>
      );
    case 'sports':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
          <path d="M12 3v18M3 12h18M5.5 6.5c2.5 2 10.5 2 13 0M5.5 17.5c2.5-2 10.5-2 13 0" stroke="currentColor" strokeWidth="1.3" />
        </svg>
      );
    case 'casino':
      return (
        <svg {...common}>
          <rect x="4" y="3" width="11" height="15" rx="1.5" stroke="currentColor" strokeWidth="1.8" transform="rotate(-8 9.5 10.5)" />
          <rect x="9" y="5" width="11" height="15" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="14.5" cy="12.5" r="1.4" fill="currentColor" />
        </svg>
      );
    case 'menu':
      return (
        <svg {...common}>
          <path d="M5 7h14M5 12h14M5 17h14" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
        </svg>
      );
    default:
      return null;
  }
}

interface BottomNavProps {
  onOpenWheel: () => void;
}

export function BottomNav({ onOpenWheel }: BottomNavProps) {
  const { t } = useTranslation('nav');

  return (
    <nav className="bottom-nav bottom-nav-ton" aria-label="Mobile">
      <NavLink to="/cashier" className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="wallet" />
        </span>
        <span className="label">{t('wallet')}</span>
      </NavLink>

      <NavLink to="/sports" className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="sports" />
        </span>
        <span className="label">{t('sports')}</span>
      </NavLink>

      <LuckyWheelNavButton onOpen={onOpenWheel} />

      <NavLink to="/" end className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="casino" />
        </span>
        <span className="label">{t('casino')}</span>
      </NavLink>

      <NavLink to="/menu" className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="menu" />
        </span>
        <span className="label">{t('menu')}</span>
      </NavLink>
    </nav>
  );
}
